<template>
  <Container type="card-full">
    <div slot="header">
      <!-- <el-button @click="addNotice" :loading="btnLoading">新增</el-button>
      <el-button @click="chgNotice" :loading="btnLoading">修改</el-button>
      <el-button @click="delNotice" :loading="btnLoading">删除</el-button>
      <el-button @click="setPublic" :loading="btnLoading">发布</el-button>
      <el-button @click="cancelPublic" :loading="btnLoading">取消发布</el-button> -->
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div
         style="margin-bottom:20px;font-size:18px;font-weight:bold"
    >
      主题：{{wmenu.wmenuname}}
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            @cellDblClick="viewProject" :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick" @pagechange="pagechange"
            :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
    >
          <template slot="btn">
            <div class="btn-box">
                <vxe-button type="text"  icon="vxe-icon--plus" @click="addNotice" :loading="btnLoading">新增</vxe-button>
                <vxe-button type="text" icon="el-icon-position" @click="setPublic" :loading="btnLoading">发布</vxe-button>
                <vxe-button type="text" icon="el-icon-remove" @click="cancelPublic" :loading="btnLoading">取消发布</vxe-button>
            </div>
          </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'noticeIndex',
    data () {
      return {
        wmenu: {},
        wmenutitle: '',
        list: [],
        btn:{},
        btnLoading: false,
        isOperate:true,
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'wmenuname', fieldtype: 'C', title: '菜单',calculExpr:'', addNewRowFlg: false},
          { field: 'noticetitle', fieldtype: 'C', title: '主题',calculExpr:'',addNewRowFlg: false},
          { field: 'noticestatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false},
          { field: 'username', fieldtype: 'C', title: '发布人',calculExpr:'',addNewRowFlg: false},
          { field: 'noticetime', fieldtype: 'C', title: '发布时间',formatter: ["toDateString", "yyyy-MM-dd"],calculExpr:'',addNewRowFlg: false}
        ],
        notice: {},
        query: {
          wmenuid: this.$route.params.form.wmenuid,
          noticefromid: this.$route.params.form.noticefromid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CHG', () => this.chgNotice())
      this.$on('DEL', () => this.delNotice())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async init() {
        this.query = {
          wmenuid: this.$route.params.form.wmenuid,
          noticefromid: this.$route.params.form.noticefromid,
          total: 0,
          limit: 20,
          offset: 0
        }
        this.wmenu = this.$route.params.form
        this.list = []
        this.btnLoading = false
        this.notice = {}
        if(this.wmenu.project){
          this.wmenutitle = '关于'+ this.wmenu.project.projectname +'(项目编号：'+ this.wmenu.project.projectcode + ')'+'的' + this.wmenu.wmenuname
        }
      },
      vggridClick(code,row){
        this.notice = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'womIndex'})
      },
      async viewProject(row) {
        this.notice = row.row
        this.notice.wmenu = this.wmenu
        if(this.wmenu.project){
          this.notice.noticetitle = this.wmenutitle
          this.notice.porjectid = this.wmenu.project.projectid
        }
        this.$router.push({name: 'noticeForm', params: {form: this.notice, type: 3}})
      },
      async addNotice () {

        let form = {
          noticeid: 0,
          noticewmenuid: this.wmenu.wmenuid,
          noticefromid:this.wmenu.noticefromid,
          noticestatus: '0',
          wmenu: this.wmenu
        }

        if(this.wmenu.project){
          form.noticetitle = this.wmenutitle
          form.porjectid = this.wmenu.project.projectid
        }

        this.$router.push({name: 'noticeForm', params: {form: form, type: 1}})
      },
      async chgNotice () {
        // if(!this.notice.id){
        //   this.$message.warning('请选择一行！')
        //   return
        // }
        this.notice.wmenu = this.wmenu
        if(this.wmenu.project){
          this.notice.noticetitle = this.wmenutitle
          this.notice.porjectid = this.wmenu.project.projectid
        }
        this.$router.push({name: 'noticeForm', params: {form: this.notice, type: 2}})
      },
      async delNotice () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/notice/delNotice',
            method: "post",
            data: this.notice
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.notice = row.row
      },
      async setPublic() {
        if(!this.notice.id){
          this.$message.warning('请选择一行！')
          return
        }
        let model = {noticeid: this.notice.noticeid,userid: this.$store.getters.loginUser.userid}
        if (this.wmenu.project) {
          model.project = {projectid: this.wmenu.project.projectid, flg: 1}
          model.type = this.wmenu.wmenudatawhere
        }
        let res = await request({
          method: 'post',
          url: '/ywgl/notice/pubNotice',
          data: model
        })

        if (res.issuccess===1) {
          this.getPageList()
          this.$message.success('发布成功')
        } else {
          this.$message.error('发布失败')
        }
      },
      async cancelPublic() {
        if(!this.notice.id){
          this.$message.warning('请选择一行！')
          return
        }
        let model = {noticeid: this.notice.noticeid,userid: this.$store.getters.loginUser.userid}
        if (this.wmenu.project) {
          model.project = {projectid: this.wmenu.project.projectid, flg: null}
          model.type = this.wmenu.wmenudatawhere
        }
        let res = await request({
          method: 'post',
          url: '/ywgl/notice/cancelPubNotice',
          data: model
        })
        if (res.issuccess===1) {
          this.getPageList()
          this.$message.success('取消发布成功')
        } else {
          this.$message.error('取消发布失败')
        }
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/notice/getPageList',
          params: this.query
        })
        console.log('-------res.list---------',res.list);
        this.list = res.list

        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">
.btn-box{
  overflow: hidden;
    .vxe-button{
      padding: 10px 10px;
      font-size: 16px;
    }
}
</style>
